var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#edeeef",
    width: "64px",
    height: "64px",
    viewBox: "0 -1.5 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#edeeef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.698 16.885c.063-.126.063-.252.126-.377 1.512-5.923-2.08-12.853-8.254-16.507 1.952 2.446 3.132 5.582 3.132 8.995 0 1.032-.108 2.038-.313 3.009l.017-.095c-.087.39-.195.728-.33 1.052l.015-.041c-.2-.111-.365-.215-.524-.327l.019.012c-4.757-3.149-8.901-6.575-12.651-10.389l-.011-.011c2.438 3.602 4.965 6.75 7.722 9.678l-.036-.039c-4.121-2.64-7.702-5.378-11.039-8.381l.076.067c.474.784.972 1.463 1.524 2.093l-.014-.017c3.3 4.423 6.99 8.272 11.099 11.626l.117.092c-3.213 1.955-7.687 2.08-12.224 0-1.203-.57-2.236-1.2-3.195-1.923l.046.033c2.022 3.147 4.88 5.601 8.261 7.079l.12.047c1.693.839 3.687 1.331 5.796 1.331s4.103-.491 5.874-1.365l-.078.035h.064c.146-.065.271-.15.378-.252h-.001c1.512-.756 4.474-1.573 6.112 1.573.44.882 1.259-3.213-1.827-6.994z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.693a73842f75aefc5f343b02e608053f.svg";
export { ForwardRef as ReactComponent };